// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"225":"very-logo","305":"ocean-logo","467":"ASOS-logo","638":"capital-one-logo","749":"littlewoods-logo","766":"think-money-logo","908":"luma-logo"}[chunkId] + "." + {"225":"7fbd9403","305":"08859a87","467":"569d69cf","638":"d67aebe6","749":"31252007","766":"9f1ac02a","908":"d914e54d"}[chunkId] + ".chunk.js";
};